import { SKELETON_KEY, SKELETON_KEY_DATE, SKELETON_KEY_NUMBER } from './skeletonFactory';

export function skeletonOrder() {
  return {
    installation: SKELETON_KEY,
    client: SKELETON_KEY,
    status: SKELETON_KEY,
    entryDate: SKELETON_KEY_DATE,
    multilanguage: SKELETON_KEY,
    tag: SKELETON_KEY,
    serialNumber: SKELETON_KEY,
    tagAmount: SKELETON_KEY_NUMBER,
    experience: SKELETON_KEY,
    supplierOrder: SKELETON_KEY,
    supplierReference: SKELETON_KEY,
    customerReference: SKELETON_KEY
  };
}
